/**
 * Builds a CSV string from a matrix of rows and triggers a browser download.
 * Values are quoted and internal quotes escaped per RFC 4180. A UTF-8 BOM is
 * prepended so Cyrillic product names open correctly in Excel.
 */
const escapeCell = (value: unknown): string => {
  const str = value === null || value === undefined ? '' : String(value);
  return `"${str.replace(/"/g, '""')}"`;
};

export const buildCsv = (rows: Array<Array<unknown>>): string =>
  rows.map((row) => row.map(escapeCell).join(',')).join('\r\n');

export const downloadCsv = (filename: string, rows: Array<Array<unknown>>): void => {
  const csv = buildCsv(rows);
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
